import { render, staticRenderFns } from "./activity-history.vue?vue&type=template&id=39fc9a7e"
import script from "./activity-history.vue?vue&type=script&lang=ts"
export * from "./activity-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports